// Centralized syntax highlighting theme configuration
import { 
  oneLight, 
  // vscDarkPlus,
  // oneDark,
  // materialDark,
  // materialOceanic,
  // atomDark,
  nightOwl,
  // gruvboxDark,
  // vsDark,
  // solarizedDarkAtom,
  // a11yDark,
  // dark,
  // coldarkDark,
  // duotoneDark
} from "react-syntax-highlighter/dist/esm/styles/prism";

// CHANGE THESE TO TEST DIFFERENT THEMES
export const LIGHT_THEME = oneLight;
export const DARK_THEME = nightOwl; // Options: vscDarkPlus, materialDark, materialOceanic, atomDark, nightOwl, gruvboxDark, vsDark, solarizedDarkAtom, a11yDark, dark, coldarkDark, duotoneDark

// Style map for convenience (used by EditorPreview)
export const PRISM_STYLES = {
  light: LIGHT_THEME,
  dark: DARK_THEME,
};